/**
 * Environment variable validation
 * Ensures required configuration is present at startup
 */

const REQUIRED_ENV_VARS = [
  'VITE_SUPABASE_URL',
  'VITE_SUPABASE_PUBLISHABLE_KEY',
] as const;

export function validateEnvVars(): void {
  const missing: string[] = [];

  for (const key of REQUIRED_ENV_VARS) {
    if (!import.meta.env[key]) {
      missing.push(key);
    }
  }

  if (missing.length > 0) {
    const message = `Missing required environment variables: ${missing.join(', ')}`;
    console.error(`[ENV CHECK] ${message}`);

    // In production, throw to prevent the app from running misconfigured
    if (import.meta.env.PROD) {
      throw new Error(message);
    }
  }
}
